/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   Memoized function to determine if date button is disabled
 */

import addDays from 'date-fns/addDays'
import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'
import isWithinInterval from 'date-fns/isWithinInterval'
import subDays from 'date-fns/subDays'
import { useMemo } from 'react'

import { UndefinedOrDate } from '../types'

export const useIsDisabled = (
  currentDate: UndefinedOrDate,
  disableForeverFrom: UndefinedOrDate,
  disableForeverTo: UndefinedOrDate,
  disabledRanges?: ReadonlyArray<readonly [startDate: Date, endDate: Date]>
) =>
  useMemo(() => {
    if (currentDate && disableForeverTo) {
      if (isBefore(currentDate, addDays(disableForeverTo, 1))) {
        return true
      }
    }

    if (currentDate && disableForeverFrom) {
      if (isAfter(currentDate, subDays(disableForeverFrom, 1))) {
        return true
      }
    }

    const inAnyIgnoredRange =
      currentDate &&
      disabledRanges?.some(([start, end]) => {
        return isWithinInterval(currentDate, {
          start,
          end,
        })
      })

    if (inAnyIgnoredRange) {
      return true
    }

    return false
  }, [currentDate, disableForeverTo, disableForeverFrom, disabledRanges])
